import {config} from '../../config';

export const homePages = [...config.supportedCountries];

export const isHomePage = (path: string): boolean => {
  // build paths like "/at/" from "at"
  const availableHomePagePaths = homePages.map(country => `/${country}/`);
  return availableHomePagePaths.includes(path);
};
